import classnames from 'classnames';
import * as React from 'react';
import { requiredIndicator } from './form_required_indicator.css.js';

/**
 * Indicates that a certain form input, or an entire fieldset, is required. Internal use only.
 */
const FormRequiredIndicator = ({ className }) => (React.createElement("span", { "aria-hidden": "true", className: classnames(requiredIndicator, className) }, "*"));

export { FormRequiredIndicator };
